import { ACTION_CHANGE_QUANTITY_ITEM_CART } from './types'

const changeQuantityItemCart = (container, payload) => ({
    payload,
    type: ACTION_CHANGE_QUANTITY_ITEM_CART,
})

export default changeQuantityItemCart
